import React, { Component } from "react";
import styled from "styled-components";

class DeleteButton extends Component {

  render() {
    return (
      <DeleteButtonStyle onClick={this.props.onClick} className="delete-button">
        {this.props.children}
      </DeleteButtonStyle>
    )
  }
}

export default DeleteButton;


const DeleteButtonStyle = styled.button`
  background-color: #ffffff;
  border: 1px solid #FF4242;
  color: #FF4242;
  width: 120px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
`;